import { forceLogout } from './forceLogout';

export const BASE_API_URL = 'https://ps9et7hsp3.execute-api.eu-central-1.amazonaws.com/frontend'; //LIVE
//export const BASE_API_URL = 'https://shhhasjlie.execute-api.eu-central-1.amazonaws.com/frontend'; //TEST

// Token mentése
export const saveToken = (token: string): void => {
  localStorage.setItem('authToken', token);
};

// Token lekérése
export const getToken = (): string | null => {
  return localStorage.getItem('authToken');
};

// Refresh token lekérése
export const getRefreshToken = (): string | null => {
  return localStorage.getItem('refreshToken');
};

// Bejelentkezett állapot ellenőrzése
export const isLoggedIn = (): boolean => {
  return getToken() !== null;
};

const isTokenExpired = (exp: string): boolean => {
  if (!exp) return true;
  console.log(exp)
  // ha szám (epoch sec/ms) jön
  const asNum = Number(exp);
  if (Number.isFinite(asNum)) {
    const ms = asNum > 1e12 ? asNum : asNum * 1000; // sec -> ms
    return Date.now() >= ms;
  }

  // pl.: "2025-09-04 14:18:27.632648+00:00" -> ISO-kompatibilis
  const normalized = exp.replace(' ', 'T').replace(/\.\d+/, '');
  const ms = Date.parse(normalized);
  if (!Number.isFinite(ms)) return true;

  return Date.now() >= ms;
};

// duplarendelések ellen (ha párhuzamosan több hívás fut)
let handledExpiry = false;
let isRefreshing = false;

// Token refresh függvény
const refreshToken = async (): Promise<boolean> => {
  if (isRefreshing) {
    // Ha már refresh folyamatban van, várunk
    return new Promise((resolve) => {
      const checkRefresh = () => {
        if (!isRefreshing) {
          resolve(true);
        } else {
          setTimeout(checkRefresh, 100);
        }
      };
      checkRefresh();
    });
  }

  const refreshTokenValue = getRefreshToken();
  if (!refreshTokenValue) {
    return false;
  }

  isRefreshing = true;

  try {
    const response = await fetch(BASE_API_URL, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        operation: 'refresh_jw_token',
        payload: {
          refresh_token: refreshTokenValue,
        },
      }),
    });

    if (!response.ok) {
      throw new Error('Token refresh failed');
    }

    const result = await response.json();

    if (result.error) {
      throw new Error(result.error);
    }

    // Új tokenek mentése (ugyanúgy mint a login-ban)
    const { 
      token, 
      expiration, 
      refresh_token: newRefreshToken, 
      refresh_token_expiration: newRefreshTokenExpiration 
    } = result;

    const cleanToken = token.replace(/^"|"$/g, '');
    const cleanRefreshToken = newRefreshToken ? newRefreshToken.replace(/^"|"$/g, '') : '';

    localStorage.setItem('authToken', cleanToken);
    localStorage.setItem('tokenExpiration', expiration);
    localStorage.setItem('refreshToken', cleanRefreshToken);
    localStorage.setItem('refreshTokenExpiration', newRefreshTokenExpiration);

    return true;
  } catch (error) {
    console.error('Token refresh error:', error);
    return false;
  } finally {
    isRefreshing = false;
  }
};


// Általános API hívás wrapper
export const fetchApi = async (operation: string, payload: Record<string, any> = {}): Promise<any> => {
  let token = getToken();
  const tokenExpiration = localStorage.getItem("tokenExpiration");

  // Ha a token lejárt, próbáljuk meg refresh-elni
  if (token && tokenExpiration && isTokenExpired(tokenExpiration)) {
    console.log('Token expired, attempting to refresh...');
    
    const refreshSuccess = await refreshToken();
    if (refreshSuccess) {
      // Új token lekérése
      token = getToken();
      console.log('Token refreshed successfully');
    } else {
      // Ha a refresh nem sikerült, logout
      if (!handledExpiry) {
        handledExpiry = true;
        alert('A munkamenet lejárt. Kérlek, jelentkezz be újra.');
        forceLogout();
      }
      throw new Error('TOKEN_EXPIRED');
    }
  }

  // Minden híváshoz automatikusan hozzáadja a token-t (ha van)
  if (token) {
    payload.jwt_token = token;
  }

  console.log(`API hívás: ${operation}`, payload);

  const response = await fetch(BASE_API_URL, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      operation,
      payload
    }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    console.error(`API hiba (${operation}):`, errorText);
    throw new Error(errorText || 'API request failed');
  }

  return response.json();
};
